export default __webpack_public_path__ + "images/26d31e208f9556fb6e2547a9be7ac9f5.svg";